import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, admin = false }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center bg-[#0B0F19]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-700 border-t-[#FF2D78]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/players" replace />;
  return children;
};
